<template>

    <template v-if="isLoading || count > 0">
        <slot></slot>
    </template>

    <NoDataMessage v-else></NoDataMessage>
    
</template>

<script setup>
import { inject } from "vue";

import NoDataMessage from './NoDataMessage.vue'

const props     = defineProps({
    count       : Number,
})

const isLoading     = inject('isLoading')

</script>